
import { createRouter, createWebHistory } from 'vue-router'
import stateView from '../views/stateView.vue'
import componentTester from '../views/componentTester.vue'
import portfolioView from '../views/portfolioView.vue'
import portfolioAnalysis from '../views/portfolioAnalysis.vue'
import toolsView from '@/views/toolsView.vue'
import terminalView from '@/views/terminalView.vue'
import ChartSimulator from '@/components/ChartSimulator.vue'
import IdiChartSimulator from '@/components/IdiChartSimulator.vue'
import ladderView from '@/views/ladderView.vue'
import edgesEvolView from '@/views/edgesEvolView.vue'

const routes = [
  {
    path: '/state',
    name: 'StateStore',
    component: stateView,
    meta: {title: 'Maya.ai | {currentPrice}'}
  },
  {
    path: '/tester',
    name: 'Tester',
    component: componentTester,
    meta: {title: 'Maya.ai - Tester | {currentPrice}'}
  },
  {
    path: '/tools',
    name: 'Tools',
    component: toolsView,
    meta: {title: 'Maya.ai | Tools | {currentPrice}'}
  },
  {
    path: '/terminal',
    name: 'Terminal',
    component: terminalView,
    meta: {title: 'Maya.ai | Terminal | {currentPrice}'}
  },
  {
    path: '/ladder',
    name: 'Ladder',
    component: ladderView,
    meta: {title: 'Maya.ai | Ladder | {currentPrice}'}
  },
  {
    path: '/pnl',
    name: 'EdgesEvol',
    component: edgesEvolView,
    meta: {title: 'Maya.ai | PnL | {currentPrice}'}
  },
  {
    path: '/analyze',
    name: 'portfolioAnalysis',
    component: portfolioAnalysis,
    meta: {title: 'Maya.ai | Analysis | {currentPrice}'}
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: portfolioView,
    meta: {title: 'Maya.ai | Portfolio'}
  },
  {
    path: '/simulator',
    name: 'Simulator',
    component: ChartSimulator,
    meta: {title: 'Maya.ai | Simulator | {currentPrice}'}
  },
  {
    path: '/idi-chart',
    name: 'IdiChart',
    component: IdiChartSimulator,
    props: { modules: ['portfolio', 'inventory', 'hover', 'desova'] },
    meta: {title: 'Maya.ai | IDI Candlestick | {currentPrice}'}
  },
]

const router = createRouter({ history: createWebHistory(process.env.BASE_URL), routes })

export default router
